import React, {useState} from "react";
import PropTypes from 'prop-types';
import { Button } from "react-bootstrap";
import { Translate } from "../Translator";
import { ConfigurationApiForward } from "../../ExternalApi/ConfigurationApi"
import { IsEmptyString } from "../GeneralFunctions.jsx";


const DatasourceBullhorn = (props) => {

    const [mRepainter, SetRepainter] = useState(false); 
    const [mBullhornUrl, SetBullhornUrl] = useState(""); 
    const [mError, SetError] = useState("") 

    const SetReady = () => 
    {
        props.OnSetReady(props.IntegrationSettings.DatasourceSettings.RefreshToken)
    }

    const GetTokens = async () => 
    {
        const BullhornRedirectUrlParams = new URL(mBullhornUrl).searchParams;
        const Code = BullhornRedirectUrlParams.get("code");
        
        const TokenUrl = "https://auth.bullhornstaffing.com/oauth/token" +
            "?grant_type=authorization_code" +
            "&client_id=" + props.IntegrationSettings.DatasourceSettings.ClientId +
            "&client_secret=" + props.IntegrationSettings.DatasourceSettings.ClientSecret +
            "&code=" + Code

        let Result = await ConfigurationApiForward(
            props.SecurityToken, 
            TokenUrl, 
            "POST", 
            "", 
            "application/json", 
            "application/json")
        if (Result != null)
        {
            UpdateDatasourceSetting("AccessToken", Result.data.access_token)
            UpdateDatasourceSetting("RefreshToken", Result.data.refresh_token)
        }
        else
        {
            SetError("Failed to retrieve tokens")
        }
    }

    const StartOAuth = () =>
    {
        const OAuthUrl = "https://auth.bullhornstaffing.com/oauth/authorize?client_id=" + props.IntegrationSettings.DatasourceSettings.ClientId + "&response_type=code"
        window.open(OAuthUrl, "_blank", 'popup=yes,titlebar=0,left=' + ((screen.availWidth - 750)/2)  + ',top=' + ((screen.availHeight - 750)/2)  + ',width=750,height=750')
    }

    const UpdateDatasourceSetting = (aIdentifier,aNewValue) =>
    {
        SetRepainter(!mRepainter)
        props.IntegrationSettings.DatasourceSettings[aIdentifier] = aNewValue

        SetReady()
    }
    
    const BrandingId = sessionStorage.getItem("BrandingId")

    return <div className="scriptitembody">
        <div className="wizardfieldname">{Translate("Client ID").toUpperCase()} <span className="redtext">*</span></div>
        <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings.ClientId} onChange={evt => UpdateDatasourceSetting("ClientId", evt.target.value)} className="wizardinputfield"/></div>
        <div className="wizardfieldname">{Translate("Client secret").toUpperCase()} <span className="redtext">*</span></div>
        <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings.ClientSecret} onChange={evt => UpdateDatasourceSetting("ClientSecret", evt.target.value)} className="wizardinputfield"/></div>
        {IsEmptyString(props.IntegrationSettings.DatasourceSettings.ClientId) || IsEmptyString(props.IntegrationSettings.DatasourceSettings.ClientSecret) ?
            <Button disabled variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} type="submit">{Translate("Connect")}</Button> :
            <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StartOAuth()} type="submit">{Translate("Connect")}</Button>
        }
        
        <div className="wizardfieldname">{Translate("Bullhorn Code URL").toUpperCase()} <span className="redtext">*</span></div>
        <div className="wizardfieldvalue"><input autoComplete="new-password" placeholder={Translate("Full Bullhorn OAuth URL after authorization")} type="text" value={mBullhornUrl} onChange={evt => SetBullhornUrl(evt.target.value)} className="wizardinputfield"/></div>
        <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => GetTokens()} type="submit">{Translate("Get tokens")}</Button><br/>



        {mError ? <div className="scriptitembody">{mError}</div> : 
            (props.IntegrationSettings.DatasourceSettings.RefreshToken ? <div className="scriptitembody">{Translate("$Application connection token received succesfully").replace("$Application","Bullhorn")}</div> : <></>) 
        }

    </div>

}

DatasourceBullhorn.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceBullhorn